<template>
  <div  id="preview" class="printSheet">
    <div class="page" v-for="(orders, o) in tables" :key="`orders-${o}`">
      <div class="block1">
        <div>
          <div>
            <div>時間: <span :style="{fontSize: '24px', whiteSpace: 'nowrap'}">{{toDate(item.visitDate)}} <span :style="{fontWeight: 700}">{{item.visitTime}}</span></span></div>
            <div>桌數: <span :style="{fontSize: '24px', fontWeight: 700}">{{item.Orders.filter(e => e.unit === '桌').map(e => e.count).reduce((a, b) => a + b, 0)}}</span> 桌 / 人數: <span :style="{fontSize: '24px', fontWeight: 700}">{{item.reserveNum+item.reserveNumChild}}</span>人</div>
          </div>
          <div>
            <div>預約人: <span :style="{fontWeight: 700}">{{item.orderer}}</span></div>
            <div>預約電話: <span :style="{fontWeight: 700}">{{item.ordererTel}}</span></div>
          </div>
        </div>
        <div>
          <div :style="{color:'#FFF'}">桌次</div>
          <div class="tables">
            <div class="table" v-for="x in item.tables" :key="`table-${o||0}-${x}`">{{x}}</div>
            <template v-if="(item.tables || []).length<15">
            <div class="table" v-for="x in (15 - (item.tables || []).length)" :key="`table-${x}`"></div>
            </template>
          </div>
        </div>
      </div>
      <div class="block2">
        <div>
          <div>
            <div class="mainItemName">
              <div>{{orders.name}}</div>
              <div>{{orders.count}}桌</div>
              <div>{{formatDollarInt(orders.finalPrice||priceEach(orders))}}</div>
            </div>
            <div class="mainItem">
              <div>品項</div>
              <div class="itemsNames">
                <div v-for="(itm,i) in orders?.items" :key="`orders-${o||0}-${i}`" class="itemsName">
                <span>{{i+1}}.</span><span>{{itm.name}}</span>
              </div>
              </div>
            </div>
          </div>
          <div>
            <div class="singleItemsPrice">
              <div>加點</div>
              <div>{{reduce([...set, ...single].map(e => priceEach(e) * e.count)) ? formatDollarInt(reduce([...set, ...single].map(e => priceEach(e) * e.count))) : '$0'}}</div>
            </div>
            <div>
              <table>
                <tr :style="{backgroundColor: '#999999'}"><th>品項</th><th>數量</th><th>單價</th><th>總價</th>  </tr>
                <template v-for="(sing, s) in set">
                  <tr  :key="`set-${o}-${s}`" :style="{height: '60px'}">
                    <td :style="{paddingLeft: '18px', fontWeight:'700', fontSize: '20px'}">{{sing.name}}</td>
                    <td :style="{textAlign:'center', fontWeight:'700', fontSize: '20px'}">{{sing.count}}</td>
                    <td :style="{textAlign:'center', fontWeight:'700', fontSize: '20px'}">{{priceEach(sing)}}</td>
                    <td :style="{textAlign:'center', fontWeight:'700', fontSize: '20px'}">{{Math.ceil(priceEach(sing) * sing.count)}}</td>
                  </tr>
                  <tr v-for="(dish, d) in sing.items"  :key="`set-d-${o}-${s}-${d}`" :style="{height: '30px'}">
                    <td :style="{paddingLeft: '48px', fontWeight:'700', fontSize: '18px'}" colspan="4">{{dish.name}}</td>
                  </tr>
                </template>
                <template v-for="(sing, s) in single">
                  <tr  :key="`single-${o}-${s}`" :style="{height: '40px'}">
                    <td :style="{paddingLeft: '18px', fontWeight:'700', fontSize: '20px'}">{{sing.name}}</td>
                    <td :style="{textAlign:'center', fontWeight:'700', fontSize: '20x'}">{{sing.count}}</td>
                    <td :style="{textAlign:'center', fontWeight:'700', fontSize: '20px'}">{{priceEach(sing)}}</td>
                    <td :style="{textAlign:'center', fontWeight:'700', fontSize: '20px'}">{{Math.ceil(priceEach(sing) * sing.count)}}</td>
                  </tr>
                </template>
              </table>
            </div>
          </div>
        </div>
        <div>
          <p v-if="!item.remark&&!item.remarkKitchen" :style="{marginBlock: 0}">備註:</p>
          <p v-if="item.remark" :style="{marginBlock: 0}">備註: {{item.remark}}</p>
          <p v-if="item.remarkKitchen">內部備註: {{item.remarkKitchen}}</p>
        </div>
      </div>
      <div class="block3">
        <div>其他:</div>
        <div>總金額:</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    tables () {
      if (this.item && this.item.Orders && this.item.Orders.length > 0) {
        return this.item.Orders.filter(e => e.unit === '桌')
      }
      return []
    },
    set () {
      if (this.item && this.item.Orders && this.item.Orders.length > 0) {
        return this.item.Orders.filter(e => e.unit !== '桌' && e.t === 'set')
      }
      return []
    },
    single () {
      if (this.item && this.item.Orders && this.item.Orders.length > 0) {
        return this.item.Orders.filter(e => e.unit !== '桌' && e.t === 'single')
      }
      return []
    }
  }

}
</script>

<style lang="scss" scoped>
.itemsNames {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.itemsName {
  max-height: 160mm;
  font-size: 28px;
  font-weight: 700;
  padding-left: 28px;
  text-align: start;
}
.singleItemsPrice, .mainItemName {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-inline: 10px;
}
.singleItemsPrice>div, .mainItemName>div {
  font-size: 18px;
  font-weight: 700;
}
.mainItem {

}
.mainItem>div:nth-child(1) {
  height: 28px;
  background-color: #999999;
  color: #FFFFFF!important;
  text-align: start;
  padding-left: 24px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
table {
  border-collapse: collapse;
  width: 100%;
}
tr {
  width: 100%;
}
th {
  color: #FFFFFF!important;
  border: none;
  height: 28px;
}
th:nth-child(1) {
  width: 50%;
  text-align: start;
  padding-left: 24px;
}
td {
  font-size: 22px;
}
td:nth-child(1) {
  text-align:start;
}
#preview {
  width: fit-content;
  height: fit-content;
  padding: 0;
  z-index: 100;
  position: fixed;
  top: 100vh;
  // top: 10px;
  left: 90px;
  border: 5px solid peachpuff;
  transform: scale(.75);
}
#preview * {
  color: #5E5E5E;
}
.block2 {
  display: grid;
  grid-template-rows: 1fr 107px;
  padding: 6px;
  gap: 6px;
}
.block2>div:nth-child(1) {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
}
.block2>div:nth-child(1)>div{
  display: grid;
  grid-template-rows: 45px 1fr;
  gap: 6px;
}
.block2>div:nth-child(1)>div>div{
  border: 1px solid #5E5E5E;
}
.block2>div:last-child {
  border: 1px solid #5E5E5E;
  text-align: start;
  padding: 8px 16px;
}
.page {
  width: 200mm;
  height: 297mm;
  padding: 10mm;
  display: grid;
  flex-direction: column;
  gap: 11px;
  grid-template-rows: 200px 1fr 74px;
  background-color: #FFFFFF;
  max-height: 297mm;

}
.block2, .block1, .block3 {
  width: 100%;
  border: 3px solid #5E5E5E;
  max-width: 794px;
}
.block1 {
  display: grid;
  grid-template-columns: 38% 1fr;
}
.block1>div:nth-child(1) {
  border-right: 1px solid #5E5E5E;
  display: grid;
  grid-template-rows: 1fr 1fr;
}
.block1>div:nth-child(1)>div:nth-child(1) {
  border-bottom: 1px solid #5E5E5E;
}
.block1>div:nth-child(1)>div{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;
  padding-left: 16px;
  font-size: 20px;
}
.block1>div:nth-child(2) {
  border-right: 1px solid #5E5E5E;
  display: grid;
  grid-template-rows: 36px 1fr;
}
.block1>div:nth-child(2)>div{
  text-align: start;
}
.block1>div:nth-child(2)>div:nth-child(1) {
  background-color: rgb(128, 128, 128);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #FFFFFF;
  padding-inline: 24px;
  font-size: 16px;
  text-align: start;
}

.block1>div:nth-child(1)>div>div {
  text-align: start;
  white-space: nowrap;
}
.tables {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  align-items: center;
  justify-content: center;
}
.table {
  min-width: 50px;
  width: 70px;
  border-bottom: 1px solid #5E5E5E;
  height: 36px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
}
.block3 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.block3>div:nth-child(1) {
  border-right: 1px solid #5E5E5E;
}
.block3>div{
  text-align: start;
  padding: 8px 16px;
  font-size: 16px;
}

</style>
